enum BaubleTypes {
  Red = 'Red',
  Blue = 'Blue',
  Yellow = 'Yellow',
}
export default BaubleTypes;
